import React from 'react';
import './mainSplitPopup.css';
import {
  SplitImageBodyPanel,
  SplitMediaCrmFormPanel,
} from '../../../Panel/Split/ImageBody/splitImageBodyPanel';
import { SplitImageLabelPanel } from '../../../Panel/Split/ImageLabel/splitImageLabelPanel';

const returnPopupTextColor = (color) =>
  color ? `text-${color?.classname}` : '';

export const MainSplitBodyPopup = (props) => (
  <div
    style={{ background: props?.color ? props?.color?.hex : 'white' }}
    className={`relative main-split-popup overflow-y-scroll no-scrollbar flex w-full max-w-screen-lg h-screen-3/4 max-h-full p-5 ${returnPopupTextColor(
      props?.textColor
    )}`}>
    <SplitImageBodyPanel {...props} />
  </div>
);

export const MainSplitMediaCrmFormPopup = (props) => (
  <div
    style={{ background: props?.color ? props?.color?.hex : 'white' }}
    className={`relative main-split-popup overflow-y-scroll no-scrollbar flex w-full max-w-screen-lg h-screen-3/4 max-h-full p-5 ${returnPopupTextColor(
      props?.textColor
    )}`}>
    <SplitMediaCrmFormPanel {...props} />
  </div>
);

export const MainSplitLabelPopup = (props) => (
  <div
    style={{ background: props?.color ? props?.color?.hex : 'white' }}
    className={`relative main-split-popup overflow-y-scroll no-scrollbar flex w-full max-w-screen-lg max-h-full h-screen-3/4 p-5 ${returnPopupTextColor(
      props?.textColor
    )}`}>
    <SplitImageLabelPanel {...props} />
  </div>
);
